




























import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { Stripe } from "stripe";
import { AxiosResponse } from "axios";
import { isSuccessfulResponse } from "@/services/util.service";
import { PaymentMethodType } from "@/enums/paymentMethod.enum";
import { TranslateResult } from "vue-i18n";

interface Data {
  paymentMethods: Stripe.PaymentMethod[] | [];
  customer: Stripe.Customer | undefined;
  selected: string | undefined | null;
}

export default Vue.extend({
  name: "PaymentMethodSelector",
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("paymentMethod", [
      "getListPaymentMethodsLoading",
      "getPaymentMethods",
    ]),
    ...mapGetters("customer", ["getCustomersLoading"]),
  },
  data(): Data {
    return {
      paymentMethods: [],
      customer: undefined,
      selected: undefined,
    };
  },
  created() {
    this.init();
    this.onChange();
  },
  methods: {
    ...mapActions("paymentMethod", ["listPaymentMethods"]),
    isLoading() {
      return this.getListPaymentMethodsLoading;
    },
    init() {
      this.selected = "newCard";
      const pmPayload = {
        query: {
          customer: this.customerId,
          limit: 100,
        },
      };
      this.listPaymentMethods(pmPayload).then((response: AxiosResponse) => {
        if (isSuccessfulResponse(response)) {
          this.paymentMethods = response.data.data;
        }
      });
    },
    onChange() {
      this.$emit("change", this.selected);
    },
    selectedText() {
      const paymentMethod = this.getPaymentMethods.find(
        (pm: Stripe.PaymentMethod) => pm.id === this.selected
      );

      return paymentMethod ? this.generateItemText(paymentMethod) : "";
    },
    generateItemText(paymentMethod: Stripe.PaymentMethod): TranslateResult {
      if (paymentMethod.type === PaymentMethodType.CARD) {
        const {
          brand = "",
          last4,
          exp_month,
          exp_year,
        } = paymentMethod.card || {};
        return `${brand.toUpperCase()} **** ${last4} (${exp_month}/${exp_year})`;
      } else if (paymentMethod.type === PaymentMethodType.US_BANK_ACCOUNT) {
        const { bank_name, last4 } = paymentMethod.us_bank_account || {};
        return `${bank_name} **** ${last4}`;
      } else {
        return this.$t("payment.newPaymentMethod");
      }
    },
  },
});
